export const isForProd = process.env.REACT_APP_FOR === 'prod';

const prod = {
    auth: 'https://auth.eka.care',
    parchi: 'https://parchi.eka.care',
    tryst: 'https://tryst.eka.care',
    appointments_calendar: 'https://eka.care',
    payments: 'https://payment.eka.care',
    mixpanelToken: '8801fa535d97939e4b9c500e5f0ddec9',
};

const staging = {
    auth: 'https://aorta.dev.eka.care',
    parchi: 'https://parchi.dev.eka.care',
    tryst: 'https://tryst.dev.eka.care',
    appointments_calendar: 'https://curio.dev.eka.care',
    payments: 'https://payment.dev.eka.care',
    mixpanelToken: '301023b0a63d2fa20a516329bac66fc5',
};

export const DOCS_APP_BE_URL = (isForProd ? prod : staging).parchi;
export const APPOINTMENTS_BE_URL = (isForProd ? prod : staging).tryst;
export const BOOKING_SLUG = (isForProd ? prod : staging).appointments_calendar;
export const PAYMENTS = (isForProd ? prod : staging).payments;
export const AUTH_BASE_URL = (isForProd ? prod : staging).auth;

export const SEND_REVIEW_LINK = (aid: string) =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/request-review`;
export const END_APPOINTMENT = (visitId: string): string =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${visitId}/end-visit`;
export const SEND_SELF_ASSESSMENT_LINK = (aid: string): string =>
    `${APPOINTMENTS_BE_URL}/appointment/${aid}/send-message`;
export const FETCH_APPT_CONFIGS = (businessId: string): string =>
    `${APPOINTMENTS_BE_URL}/business/${businessId}/queue-config`;

export const FETCH_ALL_APTS_URL = ({
    clinicId,
    startTime,
    endTime,
}: {
    clinicId: string;
    startTime: string;
    endTime: string;
}): string =>
    `${APPOINTMENTS_BE_URL}/business/clinic/${clinicId}/appointments/${startTime}/${endTime}`;

export const CREATE_APT_TAG = (businessId: string): string =>
    `${APPOINTMENTS_BE_URL}/business/${businessId}/tag`;
export const ADD_A_TAG_TO_APT = (businessId: string, aid: string): string =>
    `${APPOINTMENTS_BE_URL}/business/${businessId}/appointment/${aid}/toggle-tag`;
export const USER_PREFERENCE = `${APPOINTMENTS_BE_URL}/business/queue-config/user-preference`;
export const SEND_FOLLOWUP_MESSAGE = (aid: string) =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/send-followup-reminder`;

export const ADD_FOLLOWUP_DATE = `${APPOINTMENTS_BE_URL}/appointment/alter-followup-date`;
export const CHECK_IN_APT = (aid: string) =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/check-in`;
export const MARK_PAYMENTS_AS_PAID = `${PAYMENTS}/mark_as_paid/`;

export const TOKEN_REFRESH = `${AUTH_BASE_URL}/auth/refresh`;
export const ARCHIVE_APPOINTMENT_URL = (aid: string) =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/archive-appointment`;

export const MIXPANEL_TOKEN = isForProd ? prod.mixpanelToken : staging.mixpanelToken;
export const APPOINTMENT_REMINDER_URL = (aid: string) =>
    `${APPOINTMENTS_BE_URL}/business/appointment/${aid}/send-reminder`;
